module.exports = __webpack_public_path__ + "static/img/me-img2.7c88269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/me-img2.png
// module id = biYF
// module chunks = 0